<template>
  <c-row>
    <loader v-show="loading" />
    <c-col col="12">
      <c-card>
        <c-card-header>
          <strong>Income Statement</strong>
        </c-card-header>
        <c-card-body>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Income</th>
                <th>Sumber</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data.data" :key="k">
                <td><span v-html="v.label"></span></td>
                <td>
                  <span v-if="v.amount >= 0">{{
                    v.amount | thousandSeparator
                  }}</span>
                  <span v-if="v.amount < 0"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Loader from '../../components/Loader'
import { showErrorMessage } from '../../lib/helpers'
import { HTTPAUTH } from '../../lib/httplib'
export default {
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      data: [],
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      HTTPAUTH.get("/api/v1/income-statement").then(res => {
        this.data = res.data;
        this.loading = false
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false
      });
    }
  }
}
</script>